import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [

  {
    path: '/',
    name: 'index',
    component: () => import('../components/index'),
    meta: {
      title: 'index',
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  localStorage.setItem("previousPage", from.fullPath || "/");

  if (window.innerWidth < 768 && to.meta.mobileAlternative) {
    next({ name: to.meta.mobileAlternative });
    return;
  }

  next();
})

export default router